import React from "react";
import "./Info.css";

const Info = () => {
  return (
    <div className="info-section">
      {/* Left: Image */}
   

      {/* Right: Content */}
      <div className="info-content animate-right">
        <h4>Strong, secure, weather-resistant designs crafted for modern living.</h4>
        <h2 className="hkk">Premium Aluminium Windows & Doors for Every Space</h2>
        <p>
Transform your home or workspace with our premium aluminium windows and doors, crafted for strength, style, and long-term durability. Our products offer noise reduction, rust-free performance, and effortless maintenance perfect for modern living.
Whether you need sliding systems, casement windows, partitions, or custom designs, we provide seamless installation and reliable service. Ideal for homes, offices, shops, and large projects where quality and aesthetics matter.        </p>
        <p>
Experience superior comfort and style with advanced aluminium windows and doors that combine sleek design with unmatched durability. Each unit is built using high-grade aluminium to deliver strong structural integrity, smooth movement, and weatherproof performance.
We offer complete solutions from measurement and fabrication to installation and maintenance ensuring a hassle free experience. Trusted by homeowners, architects, and builders for residential renovations, commercial setups, and industrial applications.        </p>
      </div>
    </div>
  );
};

export default Info;
